import { PaymentMethodAPI } from 'src/features/common/types';
import { PaymentMethodDTO } from 'src/features/common/types/salesforce/dto/payment-method/payment-method-dto';

export const getPaymentMethodAPIFromDTO = (productMethod: PaymentMethodDTO): PaymentMethodAPI => {
  const productMethodAPI: PaymentMethodAPI = {
    selectable: productMethod.selectable,
    paymentMethodCode: productMethod.paymentMethodCode,
    label: productMethod.label,
    description: productMethod.description,
    category: productMethod.category,
    acquiringChannels: productMethod.acquiringChannels,
  };
  return productMethodAPI;
};
